import React from 'react'
import { Resource } from 'react-admin';
import SurveySummary from './survey_summary'



const Resources = [
    <Resource name='wam_chain_to_chain_mapping' />,

    <Resource {...SurveySummary}/>,


    
]

export default Resources